(() => {
  if (window.mamoBookingEventsReady) return;
  window.mamoBookingEventsReady = true;
  const bookingHandles = new Set(['1-hour-kichijoji','20min-kichijoji','last-minute-bookings-kichijoji','1-hour','20min','1-hour-osaka','20min-osaka','last-minute-bookings-osaka','1-hour-osaka-family']);
  const allowedPages = new Set(['mamomura-tokyo','mamomura-osaka','mamo-terrace','cast','international-guide','ouchi-kyomuiyashi','marmot-village']);
  const locale = (document.documentElement.lang || 'ja').slice(0,10);
  const pagePath = location.pathname;
  let selectedStore = /osaka/.test(pagePath) ? 'osaka' : /kichijoji|mamomura-tokyo|mamo-terrace/.test(pagePath) ? 'kichijoji' : 'unknown';
  let selectedPlan = '';
  const sent = new Map();
  const channel = (() => {
    const source = new URLSearchParams(location.search).get('utm_source') || '';
    if (/^(ig|instagram)$/i.test(source) || /(^|\.)instagram\.com$/.test(host(document.referrer))) return 'instagram';
    if (/^line$/i.test(source)) return 'line';
    if (/^facebook$/i.test(source) || /(^|\.)facebook\.com$/.test(host(document.referrer))) return 'facebook';
    if (/^google$/i.test(source) || /(^|\.)google\./.test(host(document.referrer))) return 'google';
    return source ? 'other_campaign' : document.referrer ? 'referral_or_internal' : 'direct';
  })();
  function host(url) { try { return new URL(url).hostname; } catch { return ''; } }
  function destination(value) {
    try {
      const u = new URL(value,location.origin);
      if (u.origin !== location.origin) return null;
      const segments = u.pathname.split('/').filter(Boolean);
      const type = segments[segments.length-2];
      const handle = segments[segments.length-1] || '';
      if (type === 'products' && bookingHandles.has(handle)) return {kind:'product',handle,store:/osaka/.test(handle)?'osaka':/kichijoji/.test(handle)?'kichijoji':'nakano'};
      if (type === 'pages' && allowedPages.has(handle)) return {kind:'page',handle,store:/osaka/.test(handle)?'osaka':/tokyo|terrace/.test(handle)?'kichijoji':'unknown'};
      if (type === 'collections' && handle === 'plan') return {kind:'plan_list',handle,store:'unknown'};
    } catch {}
    return null;
  }
  function publish(name,extra={}) {
    const shopify = window.Shopify;
    if (!shopify || shopify.designMode || typeof shopify.customerPrivacy?.analyticsProcessingAllowed !== 'function' || !shopify.customerPrivacy.analyticsProcessingAllowed() || typeof shopify.analytics?.publish !== 'function') return;
    const own = destination(location.href);
    const payload = {store:selectedStore,plan:selectedPlan,language:locale,source:channel,page:own?.handle || 'home',...extra};
    const key = name + JSON.stringify(payload);
    if (Date.now()-(sent.get(key)||0)<800) return;
    sent.set(key,Date.now());
    try { Promise.resolve(shopify.analytics.publish('mamomura:'+name,payload)).catch(()=>{}); } catch {}
  }
  document.addEventListener('click',event=>{
    const control = event.target instanceof Element ? event.target.closest('a,button') : null;
    if (!control) return;
    const d = destination(control.getAttribute('data-mm-product-path') || control.getAttribute('href') || '');
    if (!d || (d.kind==='page' && !/mamomura-tokyo|mamomura-osaka/.test(d.handle))) return;
    selectedStore=d.store;
    if (d.kind==='product') selectedPlan=d.handle;
    publish(d.kind==='product'?'booking_click':'location_choice',{destination:d.handle});
  },true);
  const root = document.querySelector('#mtlp, #mvo');
  if (root) {
    new MutationObserver(()=>{
      const state=root.getAttribute('data-mm-calendar-state');
      if (state==='presented') publish('calendar_frame_presented',{signal:'visible_embed_frame'});
      if (state==='fallback') publish('calendar_help_presented');
    }).observe(root,{attributes:true,attributeFilter:['data-mm-calendar-state']});
  }
  window.addEventListener('message',event=>{
    if (event.origin!=='https://widget.cowlendar.com') return;
    const known=Array.from(document.querySelectorAll('iframe[src^="https://widget.cowlendar.com/booking/embed"]')).some(frame=>frame.contentWindow===event.source);
    if (!known) return;
    let payload=event.data;
    if (typeof payload==='string') { try { payload=JSON.parse(payload); } catch { return; } }
    if (payload && typeof payload==='object' && payload.action==='add_to_cart') publish('booking_add_to_cart_requested',{signal:'app_message'});
  });
})();
